import { MessageCircle } from 'lucide-react';
import { getWhatsAppLink } from '../../lib/utils';

export const StickyWhatsApp = () => {
  return (
    <a
      href={getWhatsAppLink()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-whatsapp hover:bg-whatsapp/90 text-white p-4 rounded-full shadow-lg whatsapp-pulse transition-transform hover:scale-110"
      data-testid="sticky-whatsapp-btn"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
};
